import { MediaRecordType, UserDto } from '../main';

export class MediaCommerceDto {
  id: number;
  name: string;
  user: UserDto;
  mediaId: number;
  typeRecord: MediaRecordType;
  price?: number;
  productionPrice?: number;
  durationDays?: number;
  percentages?: number;
  updatedAt: Date;
}

export class UpdateMediaCommerceDto {
  id: number;
  name: string;
  typeRecord: MediaRecordType;
  price?: number;
  productionPrice?: number;
  durationDays?: number;
  percentages?: number;
  mediaId?: number;
}

export class CreateMediaCommerceDto {
  name: string;
  mediaId: number;
  typeRecord: MediaRecordType;
  price?: number;
  productionPrice?: number;
  durationDays?: number;
  percentages?: number;
}